export default function parseUrlParams(url?: string): any {
  if (!url) {
    url = location.search;
  }
  const query = url.substr(1);
  const result: any = {};
  query.split("&").forEach((part: string) => {
    const item = part.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}
